import { Complement } from './complement';
import { ProductType } from './product-type';
import { Brand } from './brand';

export class Product {
  constructor(
    public hash?: string,
    public name?: string,
    public code?: string,
    public price?: number,
    public weight?: number,
    public description?: string,
    public needSerialNumber?: boolean,
    public productType?: ProductType,
    public brand?: Brand,
    public complements?: Complement[]
  ) { }

  get fullName() {
    return `${ this.name } (${ this.code })`;
  }

  get productStringToFindBy() {
    return `${ this.name } ${ this.code } ${ this.description }`;
  }

  clone() {
    return new Product(
      this.hash,
      this.name,
      this.code,
      this.price,
      this.weight,
      this.description,
      this.needSerialNumber,
      this.productType,
      this.brand,
      this.complements
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/product.ts